import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { BulkProposalCard } from './BulkProposalCard';
import type { RetrySyncRow } from './proposal-part.types';

interface Props {
  proposalId: string;
  rows: RetrySyncRow[];
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/**
 * Confirmation card for re-running failed syncs. Each connection is listed with the entity
 * it syncs, because a retry starts a fresh run against the live external system.
 */
export function RetrySyncsProposalCard({ proposalId, rows, resolved, onConfirm, onCancel }: Props) {
  const t = useFeatureTranslation('aiChat');

  return (
    <BulkProposalCard
      title={t('proposals.retry-syncs.title')}
      description={t('proposals.retry-syncs.countDescription', { count: rows.length })}
      proposalId={proposalId}
      rows={rows}
      rowKey={row => row.instanceId}
      primary={row => row.name}
      secondary={row => <span className='text-foreground-muted'>{row.entityType}</span>}
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
